import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, withModifiers as _withModifiers, createElementBlock as _createElementBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = ["onClick"]
const _hoisted_2 = { key: 0 }
const _hoisted_3 = {
  key: 1,
  style: {"text-align":"center"},
  class: "px-0 text-center"
}
const _hoisted_4 = { class: "text-center" }
const _hoisted_5 = { class: "text-center" }
const _hoisted_6 = ["onClick"]
const _hoisted_7 = { class: "text-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_btn_primary = _resolveComponent("v-btn-primary")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_progress_linear = _resolveComponent("v-progress-linear")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_data_table_server = _resolveComponent("v-data-table-server")!
  const _component_ImportMapping = _resolveComponent("ImportMapping")!
  const _component_oss_dialog = _resolveComponent("oss-dialog")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createBlock(_component_v_container, null, {
    default: _withCtx(() => [
      (_ctx.isAuthorized)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            (_ctx.displayImportMap)
              ? (_openBlock(), _createBlock(_component_v_row, {
                  key: 0,
                  "no-gutters": ""
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_col, { cols: "12" }, {
                      default: _withCtx(() => [
                        (!_ctx.$vuetify.display.mobile)
                          ? (_openBlock(), _createBlock(_component_v_row, {
                              key: 0,
                              "no-gutters": "",
                              class: "my-3"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_col, { cols: "2" }, {
                                  default: _withCtx(() => [
                                    (_ctx.currentUser.profile.configuration.accounting.write)
                                      ? (_openBlock(), _createBlock(_component_v_btn_primary, {
                                          key: 0,
                                          block: "",
                                          onClick: _cache[0] || (_cache[0] = ($event: any) => (
                                    _ctx.$router.push({
                                        name: 'importFec',
                                        params: {
                                            companyId: _ctx.selectedCompany.id,
                                            mode: 'all',
                                            documentType: 'FEC',
                                        },
                                    })
                                ))
                                        }, {
                                          default: _withCtx(() => _cache[12] || (_cache[12] = [
                                            _createTextVNode("Importer")
                                          ])),
                                          _: 1
                                        }))
                                      : _createCommentVNode("", true)
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_v_col, {
                                  cols: "2",
                                  class: "pl-2"
                                }, {
                                  default: _withCtx(() => [
                                    (
                                    _ctx.currentUser.profile.configuration.accounting.write &&
                                    (!_ctx.selectedCompany.profile ||
                                        _ctx.selectedCompany.profile.createPaySlip)
                                )
                                      ? (_openBlock(), _createBlock(_component_v_btn_primary, {
                                          key: 0,
                                          block: "",
                                          onClick: _cache[1] || (_cache[1] = ($event: any) => (
                                    _ctx.$router.push({
                                        name: 'importFec',
                                        params: {
                                            companyId: _ctx.selectedCompany.id,
                                            mode: 'payslip',
                                            documentType: 'FEC',
                                        },
                                    })
                                ))
                                        }, {
                                          default: _withCtx(() => _cache[13] || (_cache[13] = [
                                            _createTextVNode(" Import Silae ")
                                          ])),
                                          _: 1
                                        }))
                                      : _createCommentVNode("", true)
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_v_col, {
                                  cols: "2",
                                  class: "pl-2"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_btn_primary, {
                                      block: "",
                                      onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.displayImportMapping()))
                                    }, {
                                      default: _withCtx(() => _cache[14] || (_cache[14] = [
                                        _createTextVNode(" Import Mapping ")
                                      ])),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }))
                          : _createCommentVNode("", true)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_col, { cols: "12" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_data_table_server, {
                          headers: _ctx.headersImport,
                          items: _ctx.accountingItemImports,
                          page: _ctx.paginationImport.page,
                          "onUpdate:page": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.paginationImport.page) = $event)),
                          "sort-by": _ctx.sortBy,
                          "onUpdate:sortBy": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.sortBy) = $event)),
                          "items-per-page": _ctx.paginationImport.rowsPerPage,
                          "onUpdate:itemsPerPage": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.paginationImport.rowsPerPage) = $event)),
                          "items-per-page-options": [5, 10, 25],
                          "items-length": _ctx.paginationImport.totalItems,
                          class: "table",
                          "fixed-header": "",
                          "max-height": "60vh"
                        }, {
                          item: _withCtx((props) => [
                            _createElementVNode("tr", {
                              style: _normalizeStyle(
                                    _ctx.isRunningImportButFailed(props.item)
                                        ? 'color:red;cursor: pointer'
                                        : 'cursor: pointer'
                                )
                            }, [
                              _createElementVNode("td", null, [
                                _createTextVNode(_toDisplayString(props.item.name) + " ", 1),
                                (props.item.type === 'CONNECTOR')
                                  ? (_openBlock(), _createBlock(_component_v_icon, {
                                      key: 0,
                                      size: "x-small",
                                      rounded: "circle",
                                      right: "",
                                      color: "secondary"
                                    }, {
                                      default: _withCtx(() => _cache[15] || (_cache[15] = [
                                        _createTextVNode("$fa-plug")
                                      ])),
                                      _: 1
                                    }))
                                  : _createCommentVNode("", true)
                              ]),
                              _createElementVNode("td", {
                                onClick: _withModifiers(($event: any) => (_ctx.openErrorDialog(props.item)), ["stop"])
                              }, [
                                _createElementVNode("span", {
                                  style: _normalizeStyle(
                                            props.item.status === 'IMPORTED_WITH_ERRORS'
                                                ? 'color:red'
                                                : ''
                                        )
                                }, _toDisplayString(_ctx.$t(`accountingItemImport.status.${props.item.status}`)), 5),
                                (
                                            props.item.status.startsWith('RUNNING') &&
                                            props.item.stepCount
                                        )
                                  ? (_openBlock(), _createBlock(_component_v_progress_linear, {
                                      key: 0,
                                      color: "secondary",
                                      height: "10",
                                      "buffer-value": "0",
                                      stream: "",
                                      "model-value": 
                                            (100 * props.item.step) / props.item.stepCount
                                        
                                    }, null, 8, ["model-value"]))
                                  : _createCommentVNode("", true)
                              ], 8, _hoisted_1),
                              (_ctx.getAccountingPeriodTitle(props.item))
                                ? (_openBlock(), _createElementBlock("td", _hoisted_2, _toDisplayString(_ctx.getAccountingPeriodTitle(props.item)), 1))
                                : (_openBlock(), _createElementBlock("td", _hoisted_3, [
                                    _createVNode(_component_v_icon, {
                                      color: "secondary",
                                      size: "large"
                                    }, {
                                      default: _withCtx(() => _cache[16] || (_cache[16] = [
                                        _createTextVNode("$dot")
                                      ])),
                                      _: 1
                                    })
                                  ])),
                              _createElementVNode("td", null, _toDisplayString(_ctx.formatDateAndTime(props.item)), 1),
                              _createElementVNode("td", _hoisted_4, [
                                (
                                            props.item.status.startsWith('IMPORTED') ||
                                            _ctx.isRunningImportButFailed(props.item)
                                        )
                                  ? (_openBlock(), _createBlock(_component_v_btn, {
                                      key: 0,
                                      variant: "text",
                                      disabled: _ctx.lockImport(props.item),
                                      color: "secondary",
                                      onClick: _withModifiers(($event: any) => {
                                            _ctx.toDeleteAccountingItemImportId = props.item.id;
                                            _ctx.deleteAccountingItemImportLoading = false;
                                            _ctx.editAccountingItemImportDialog = true;
                                        }, ["stop"]),
                                      size: "small",
                                      icon: "$fa-eraser"
                                    }, null, 8, ["disabled", "onClick"]))
                                  : _createCommentVNode("", true),
                                _createVNode(_component_v_btn, {
                                  variant: "text",
                                  color: "secondary",
                                  onClick: _withModifiers(($event: any) => (_ctx.edit(props.item, undefined)), ["stop"]),
                                  disabled: props.item.type === 'CONNECTOR'
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_icon, { size: "small" }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(props.item.status.startsWith("EDITION")
                                                ? "$edit"
                                                : "$fa-eye"), 1)
                                      ]),
                                      _: 2
                                    }, 1024)
                                  ]),
                                  _: 2
                                }, 1032, ["onClick", "disabled"])
                              ]),
                              _createElementVNode("td", _hoisted_5, [
                                _createVNode(_component_v_btn, {
                                  variant: "text",
                                  color: "secondary",
                                  disabled: 
                                            _ctx.isRunningImportButFailed(props.item) ||
                                            _ctx.lockImport(props.item)
                                        ,
                                  onClick: _withModifiers(($event: any) => {
                                            _ctx.toDeleteAccountingItemImportId = props.item.id;
                                            _ctx.deleteAccountingItemImportLoading = false;
                                            _ctx.deleteAccountingItemImportDialog = true;
                                        }, ["stop"]),
                                  size: "small",
                                  icon: "$delete"
                                }, null, 8, ["disabled", "onClick"])
                              ]),
                              _createElementVNode("td", {
                                class: "text-center",
                                onClick: _withModifiers(($event: any) => (_ctx.download(props.item)), ["stop"])
                              }, [
                                _createVNode(_component_v_btn, {
                                  variant: "text",
                                  color: "secondary",
                                  disabled: !props.item.file,
                                  size: "small",
                                  icon: "$fa-cloud-download-alt"
                                }, null, 8, ["disabled"])
                              ], 8, _hoisted_6)
                            ], 4)
                          ]),
                          _: 1
                        }, 8, ["headers", "items", "page", "sort-by", "items-per-page", "items-length"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }))
              : (_openBlock(), _createBlock(_component_v_row, {
                  key: 1,
                  "no-gutters": "",
                  class: "my-3"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_col, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_ImportMapping, {
                          onCloseImportMapping: _cache[6] || (_cache[6] = ($event: any) => (_ctx.closeImportMap()))
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })),
            _createVNode(_component_oss_dialog, {
              modelValue: _ctx.deleteAccountingItemImportDialog,
              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.deleteAccountingItemImportDialog) = $event)),
              title: "Supprimer",
              error: true,
              onValid: _cache[8] || (_cache[8] = ($event: any) => (_ctx.deleteEditAccountingItemImport(true))),
              validLoading: _ctx.deleteAccountingItemImportLoading,
              width: "800px"
            }, {
              default: _withCtx(() => _cache[17] || (_cache[17] = [
                _createElementVNode("h4", { class: "text-center" }, " Êtes-vous sûr(e) de vouloir supprimer ces données importées ? ", -1)
              ])),
              _: 1
            }, 8, ["modelValue", "validLoading"]),
            _createVNode(_component_oss_dialog, {
              modelValue: _ctx.editAccountingItemImportDialog,
              "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.editAccountingItemImportDialog) = $event)),
              title: "Réediter",
              onValid: _cache[10] || (_cache[10] = ($event: any) => (_ctx.deleteEditAccountingItemImport(false))),
              validLoading: _ctx.deleteAccountingItemImportLoading,
              width: "800px"
            }, {
              default: _withCtx(() => _cache[18] || (_cache[18] = [
                _createElementVNode("div", { class: "text-center" }, [
                  _createElementVNode("h4", null, "Êtes-vous sûr(e) de vouloir rééditer les données importées ?"),
                  _createElementVNode("div", null, "Attention : les données importées seront supprimées")
                ], -1)
              ])),
              _: 1
            }, 8, ["modelValue", "validLoading"]),
            _createVNode(_component_oss_dialog, {
              modelValue: _ctx.errorDialog,
              "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.errorDialog) = $event)),
              title: "Detail sur les erreurs de l'import",
              width: "800px"
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("div", null, _toDisplayString(_ctx.selectedImport ? _ctx.selectedImport.errors : "XXX"), 1)
                ])
              ]),
              _: 1
            }, 8, ["modelValue"])
          ], 64))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}